import styles from './FieldError.module.css'

type FieldErrorProps = {
    error?: string;
}

export default function FieldError({ error }: FieldErrorProps) {
    return (
        error ? <div className={styles['error']}>
            {error}
        </div> : null
    )
}
